import { api } from '@/lib/api'
import type {
  StatusEntryRequest,
  StatusHistoryEntry,
  StatusSnapshotEntry,
  StatusTrack,
  StatusTrackValue,
  TrackRequest,
  TrackUpdateRequest,
  ValueRequest,
  ValueUpdateRequest,
} from './types'

const BASE = '/api/status-tracks'
const C = (id: number) => `/api/contracts/${id}/statuses`

export async function listTracksByConfiguration(configurationCode: string, activeOnly = true): Promise<StatusTrack[]> {
  const r = await api.get<StatusTrack[]>(`${BASE}/configuration/${configurationCode}`, { params: { activeOnly } })
  return r.data
}

export async function listTracks(activeOnly = true): Promise<StatusTrack[]> {
  const r = await api.get<StatusTrack[]>(BASE, { params: { activeOnly } })
  return r.data
}

export async function createTrack(payload: TrackRequest): Promise<StatusTrack> {
  const r = await api.post<StatusTrack>(BASE, payload)
  return r.data
}

export async function updateTrack(trackId: number, payload: TrackUpdateRequest): Promise<StatusTrack> {
  const r = await api.put<StatusTrack>(`${BASE}/${trackId}`, payload)
  return r.data
}

export async function deleteTrack(trackId: number): Promise<void> {
  await api.delete(`${BASE}/${trackId}`)
}

export async function createTrackValue(trackId: number, payload: ValueRequest): Promise<StatusTrackValue> {
  const r = await api.post<StatusTrackValue>(`${BASE}/${trackId}/values`, payload)
  return r.data
}

export async function updateTrackValue(trackId: number, valueId: number, payload: ValueUpdateRequest): Promise<StatusTrackValue> {
  const r = await api.put<StatusTrackValue>(`${BASE}/${trackId}/values/${valueId}`, payload)
  return r.data
}

export async function deleteTrackValue(trackId: number, valueId: number): Promise<void> {
  await api.delete(`${BASE}/${trackId}/values/${valueId}`)
}

export async function reorderTrackValues(trackId: number, ids: number[]): Promise<void> {
  await api.put(`${BASE}/${trackId}/values/order`, { ids })
}

export async function getStatusSnapshot(contractId: number): Promise<StatusSnapshotEntry[]> {
  const r = await api.get<StatusSnapshotEntry[]>(C(contractId))
  return r.data
}

export async function getStatusHistory(contractId: number): Promise<StatusHistoryEntry[]> {
  const r = await api.get<StatusHistoryEntry[]>(`${C(contractId)}/history`)
  return r.data
}

export async function writeStatusEntry(contractId: number, payload: StatusEntryRequest): Promise<StatusSnapshotEntry> {
  const r = await api.post<StatusSnapshotEntry>(C(contractId), payload)
  return r.data
}
